import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { ZOOM_SINGLE_STORE_DEFAULT, CENTER_DEFAULT } from '../map/utils';
import { styles } from './style';

export const DATA_QA_MAP_SINGLE_STORE = 'single-store-map';

type Props = {
  latitude?: string;
  longitude?: string;
  activeRegionId?: string;
  disable?: boolean;
  onClick?: () => void;
  setMapLoaded: Dispatch<SetStateAction<boolean>>;
};

export const MapSingleStore: React.FC<Props> = ({
  setMapLoaded,
  latitude,
  longitude,
  activeRegionId = '34',
  disable,
  onClick,
}) => {
  const lat = Number(latitude) || CENTER_DEFAULT[0];
  const long = Number(longitude) || CENTER_DEFAULT[1];
  useEffect(() => {
    const { ymaps } = window;
    if (latitude && longitude) {
      ymaps.ready(init);
    }

    function init() {
      setMapLoaded(true);
      const mapInstance = new ymaps.Map(
        'map',
        {
          center: [lat, long],
          zoom: ZOOM_SINGLE_STORE_DEFAULT,
          controls: [],
          behaviors: disable ? [] : ['default'],
        },
        {
          suppressMapOpenBlock: true,
          copyrightProvidersVisible: !disable,
          copyrightUaVisible: !disable,
        },
      );

      if (onClick && mapInstance.events) {
        mapInstance.events.add('click', onClick);
      }

      if (!disable) {
        const zoomControl = new ymaps.control.ZoomControl({
          options: {
            size: 'small',
            position: {
              right: 20,
              bottom: 55,
            },
          },
        });
        mapInstance.controls.add(zoomControl);
      }
    }
  }, [activeRegionId, lat, latitude, long, longitude, disable, onClick, setMapLoaded]);

  return <div id="map" className={styles} data-qa={DATA_QA_MAP_SINGLE_STORE} />;
};
